import React from 'react';
import {
  Box,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { TextFields as TextFieldsIcon } from '@mui/icons-material';
import {
  NATIVE_DISPLAY_DENSITY_OPTIONS,
  type NativeDisplayDensity,
} from '../../utils/nativeDisplayPreferences';
import { useNativeDisplayContext } from '../../components/native/NativeDisplayProvider';

const NativeDisplaySettings: React.FC = () => {
  const { density, setDensity, isNativeShell } = useNativeDisplayContext();

  if (!isNativeShell) {
    return null;
  }

  return (
    <Card elevation={3} sx={{ mb: 3 }} id="display-settings">
      <CardContent>
        <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <TextFieldsIcon color="primary" />
          Display
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Adjust text size for the mobile app. This setting applies only in the Qixit Mail app, not on the website.
        </Typography>

        <FormControl component="fieldset">
          <FormLabel component="legend">Text size</FormLabel>
          <RadioGroup
            value={density}
            onChange={(event) => setDensity(event.target.value as NativeDisplayDensity)}
          >
            {NATIVE_DISPLAY_DENSITY_OPTIONS.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </FormControl>

        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.default',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
            Preview heading
          </Typography>
          <Typography variant="body1" sx={{ mb: 0.5 }}>
            Preview body text for message subjects and account details.
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Preview caption for dates, amounts, and folder metadata.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NativeDisplaySettings;
